import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
import { ParamsProjeto, ProjetosSimples } from "@/repositorios/projeto/projeto.modelo"
import ProjetoRepositorio from "@/repositorios/projeto/projeto.repositorio"
import { defineStore } from "pinia"
import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"

const projetosRepositorio = new ProjetoRepositorio({ utilizaCache: true })
const { leitor, resolverLeitor } = usarLeitorDeDados()
const { colher } = usarManipuladorObjetos()

const lerProjetos = leitor<ProjetosSimples, ParamsProjeto>(
  projetosRepositorio.listarProjetos,
  {
    "ordenar-por": ["asc.nome_projeto"],
    "por-pagina": 1000,
    "ativo": "igual.true"
  }
)


export const usarProjetosStore = defineStore('projetos', {
  state: (): { projetos: ProjetosSimples[] } => ({
    projetos: []
  }),
  getters: {
    projetosEntidadeGenerica: (state) => {
      return colher<ProjetosSimples, { id: string, nome: string }>(
        state.projetos,
        ["id", "nomeProjeto"],
        ["id", "nome"]
      )
    },
    estaCarregandoProjetos: () => lerProjetos.resultado.status === 'pendente'
  },
  actions: {
    async buscarTodosProjetos(parametros: ParamsProjeto = {}, flagsParaRemover: string[] = []) {
      lerProjetos.removerParametros(flagsParaRemover)
      lerProjetos.incrementarParametros(parametros)

      await lerProjetos.executar()

      resolverLeitor(lerProjetos.resultado, {
        sucesso: (dados) => {
          this.projetos = dados
        },
        erro: () => {
          this.projetos = []
          throw new Error('Erro ao buscar projetos')
        }
      })
    }
  },
})
